export default "__VITE_PUBLIC_ASSET__71616dc0__"